import React from "react";
import A from "components/layout/Link";

const Nav = ({ home, protein, carbs, fats, supps }) => {
    return (
        <header role="banner">
            <nav className="navigation">
                <A to="/" className={`home ${home ? "home--active" : ""}`}>
                    Home
                </A>
                <A
                    h="/protein"
                    className={`protein ${protein ? "protein--active" : ""}`}
                >
                    Protein
                </A>
                <A
                    h="/carbs"
                    className={`carbs ${carbs ? "carbs--active" : ""}`}
                >
                    Carbs
                </A>
                <A h="/fats" className={`fats ${fats ? "fats--active" : ""}`}>
                    Fats
                </A>
                <A
                    h="/supps"
                    className={`supps ${supps ? "supps--active" : ""}`}
                >
                    Supps
                </A>
            </nav>
        </header>
    );
};

export default Nav;
